module.exports = __webpack_public_path__ + "static/media/loading_box.2728d995.gif";